export const BLOB_FOLDERS = {
  CALL_FLOW_AUDIO: 'enamelai-call-flow-audio',
  CALL_RECORDINGS: 'enamelai-call-recordings',
  CAMPAIGN_IMAGES: 'enamelai-campaign-images',
  CLINIC_LOGO: 'enamelai-clinic-logo',
  EMAIL_ATTACHMENTS: 'enamelai-email-attachments',
  FAX_ATTACHMENTS: 'enamelai-fax-attachments',
  FAX_COVERSHEET: 'enamelai-fax-coversheet',
  FAX_INBOUND: 'enamelai-fax-inbound',
  NOTES: 'enamelai-notes',
  PATIENT_FILES: 'enamelai-patient-files',
  PORT_DOCUMENTS: 'enamelai-port-documents',
  VOICEMAIL: 'enamelai-voicemail',
}
